import { Button, DatePicker, Input } from "antd";
import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TimesheetDetailsSubsection from "./TimesheetDetailsSubsection";
import WorkerTimeline from "./WorkerTimeline";
import WorkerBreakdown from "./WorkerBreakdown";
import moment from "moment";

const path = "/admin/worksite/details/timesheet";
const tabContent = [
  {
    key: "timesheet-details",
    label: `TimeSheet Details`,
  },
  {
    key: "worker-timeline",
    label: `Worker Timeline`,
  },
  {
    key: "work-breakdown",
    label: `Work Breakdown`,
  },
];

/* function Button({ children, className = "", style = {} }) {
  return (
    <button
      className={`text-lg p-1 border-solid border-[#111111] h-100 ${className}`}
      style={{
        borderWidth: "1px",
        ...style,
      }}
    >
      {children}
    </button>
  );
} */

const TimesheetDetails = () => {
  const navigate = useNavigate();
  const { id = "", weekDayId = "" } = useParams();
  const { timesheet } = useParams();
  const [activeTab, setActiveTab] = useState("timesheet-details");
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const dateParam = urlSearchParams.get("date");
  const parsedDate = moment(dateParam);
  const formattedDate = parsedDate.format("YYYY-MM-DD");
  const startDateParam = urlSearchParams.get("start");
  const endDateParam = urlSearchParams.get("end");
  const timesheetDataParam = urlSearchParams.get("timesheetData");

  // Parse the timesheet data array from URL query parameter
  const timesheetData = timesheetDataParam
    ? JSON.parse(decodeURIComponent(timesheetDataParam))
    : [];

  const parsedStartDate = moment(startDateParam);
  const parsedEndDate = moment(endDateParam);
  const [activeDate, setActiveDate] = useState(formattedDate);

  const activeTimeSheetId = timesheetData.find((entry) =>
    moment(entry.date).isSame(activeDate, "day")
  )?.timesheetId;

  function onTabClick(item) {
    if (item) {
      setActiveTab(item.key);
      let route = `${path}/${id}/${weekDayId}/${item.key}`;
      navigate(route);
    } else {
      navigate(`${path}/${id}`);
    }
  }

  const getDate = {
    selected: (e) => {
      const selectedDate = e?.target?.value;
      const minDate = parsedStartDate.format("YYYY-MM-DD");
      const maxDate = parsedEndDate.format("YYYY-MM-DD");

      // Only allow selection within the valid range
      if (selectedDate >= minDate && selectedDate <= maxDate) {
        setActiveDate(selectedDate);
      }
    },
    next: (e) => {
      const nextDate = moment?.(activeDate).add(1, "days").format("YYYY-MM-DD");
      const maxDate = parsedEndDate.format("YYYY-MM-DD");

      // Only allow navigation if next date is within range
      if (nextDate <= maxDate) {
        setActiveDate(nextDate);
      }
    },
    previous: (today) => {
      const prevDate = moment?.(activeDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      const minDate = parsedStartDate.format("YYYY-MM-DD");

      // Only allow navigation if previous date is within range
      if (prevDate >= minDate) {
        setActiveDate(prevDate);
      }
    },
  };

  useEffect(() => {
    let origin = window.location.href.split("/");
    let length = origin.length - 1;
    const findItem = tabContent.find((item) => item.key === origin[length]);
    if (findItem) {
      setActiveTab(findItem.key);
    }
  }, []); // Add dependency array to prevent infinite re-renders

  return (
    <div className="flex flex-col gap-3 p-2 py-3">
      <div className="bg-white flex justify-center relative">
        <span
          className="inline-flex items-center gap-1 absolute left-0 select-none cursor-pointer"
          onClick={() => onTabClick()}
        >
          <FaArrowLeft />
          <p className="font-[#0F4C7D]">Return to TimeSheets</p>
        </span>
        <div className="inline-flex items-center gap-2">
          <group className="inline-flex items-center h-100 border border-black">
            <span className="border-r border-y-0 border-l-0 border-black rounded-none">
              <Button
                className={`border-0 rounded-none hover:border-0 focus:border-0 ${
                  moment(activeDate).isSame(parsedStartDate, "day")
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={getDate?.previous}
                disabled={moment(activeDate).isSame(parsedStartDate, "day")}
              >
                <HiChevronLeft className="fill-[#11111]" />
              </Button>
            </span>

            <Input
              type="date"
              className="border-0 rounded-none hover:border-0 focus:border-0"
              onChange={getDate?.selected}
              value={activeDate}
              min={parsedStartDate.format("YYYY-MM-DD")}
              max={parsedEndDate.format("YYYY-MM-DD")}
            />
            <span className="border-l border-y-0 border-r-0 border-black rounded-none">
              <Button
                className={`border-0 rounded-none hover:border-0 focus:border-0 ${
                  moment(activeDate).isSame(parsedEndDate, "day")
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={getDate?.next}
                disabled={moment(activeDate).isSame(parsedEndDate, "day")}
              >
                <HiChevronRight className="fill-[#11111]" />
              </Button>
            </span>
          </group>
        </div>
      </div>
      {/* <Tabs items={items} activeKey="2" /> */}
      <nav className="flex gap-2 bg-[#E8E8E8] p-2 font-lexend w-100">
        {tabContent.map((item) => (
          <button
            className={`p-2 px-4 font-sm rounded-md duration-250 ${
              activeTab === item.key
                ? "bg-[#0F4C7D] text-white"
                : "text-[#0F4C7D] bg-[white] border-2 border-[#0F4C7D]"
            }`}
            onClick={() => onTabClick(item)}
          >
            <p>{item.label}</p>
          </button>
        ))}
      </nav>
      <Routes>
        <Route
          path="timesheet-details"
          element={
            <TimesheetDetailsSubsection
              activeDate={activeDate}
              setActiveDate={setActiveDate}
              activeTimeSheetId={activeTimeSheetId || timesheet}
            />
          }
        />
        <Route
          path="worker-timeline"
          element={
            <WorkerTimeline
              activeDate={activeDate}
              setActiveDate={setActiveDate}
            />
          }
        />
        <Route
          path="work-breakdown"
          element={
            <WorkerBreakdown
              activeDate={activeDate}
              setActiveDate={setActiveDate}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default TimesheetDetails;
